import { render } from "./UpdateTypeOfVouchers.vue?vue&type=template&id=b4e296a8"
import script from "./UpdateTypeOfVouchers.vue?vue&type=script&lang=js"
export * from "./UpdateTypeOfVouchers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__